import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import '../styles/Footer.scss';

const Footer = () => {
  const [show, setShow] = useState(false);

  const { pathname } = useLocation();

  useEffect(() => {
    setShow(pathname !== '/sign-in');
  }, [pathname]);

  return show ? (
    <div className="footer">
      <div className="left-content">
        <h1>Know your future with Alnair</h1>
        <p>
          An immersive experience that puts attendees inside the tech — guided
          by an AI fortune teller and driven by Gen AI, Gen AI-enabled avatars,
          and haptics for real-time interactive storytelling.
        </p>
      </div>
      <hr/>
      <div className="nav-menu">
        <ul>
          <li>
            <NavLink to="/home">Home</NavLink>
          </li>
          <li>
            <NavLink to="/gallery">Gallery</NavLink>
          </li>
          {/* <li>
            <NavLink to="/how-it-works">How it works</NavLink>
          </li> */}
          <li>
            <NavLink to="/contact-us">Contact us</NavLink>
          </li>
        </ul>
        <div className="right-content">
          <Link to="/privacy-notice">Privacy Notice</Link>
          <a
              href="https://www.softserveinc.com/en-us/terms-and-conditions"
              target="_blank"
              rel="noopener noreferrer"
          >
            Terms and Conditions
          </a>
        </div>
      </div>
      <p className="copyright">© Copyright 2025 SoftServe</p>
    </div>
  ) : null;
};

export default Footer;
